// extracted by mini-css-extract-plugin
module.exports = {"toggle":"Toggle_toggle__2sedu","toggleContainer":"Toggle_toggleContainer__31V_I"};